// extracted by mini-css-extract-plugin
export default {"imageContainerOld":"A6_uXt","imageContainer":"P37eeY","defaultImage":"Il60Mt","defaultImageMobile":"awuoxZ"};